(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hg-calendar-quantity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hg-calendar-quantity')) {
    customElements.define('hg-calendar-quantity', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.attachedRoot = null;
        this.shippingSubtitles = new WeakMap();
        try {
          this.moneyFormatter = new Intl.NumberFormat(this.dataset.currency === 'EUR' ? 'de-DE' : this.dataset.locale, { style: 'currency', currency: this.dataset.currency, currencyDisplay: this.dataset.currency === 'EUR' ? 'symbol' : this.dataset.currencyCode === 'true' ? 'code' : 'narrowSymbol' });
        } catch (error) {
          this.moneyFormatter = null;
        }
        let attempts = 0;
        const attachStyle = () => {
          clearTimeout(this.timer);
          if (!this.isConnected) return;
          const offer = this.querySelector('section-store--bundle-block');
          const root = offer?.shadowRoot;
          const buyRow = this.closest('product-info')?.querySelector('form.product-form .buy-buttons');
          const template = this.querySelector('template[data-hg-quantity-style]');
          if (root && this.attachedRoot === root) return;
          if (root?.querySelector('.bundle-option') && template && offer.bundleOptions?.length && buyRow) {
            this.attachedRoot = root;
            if (!root.querySelector('[data-hg-calendar-style]')) root.append(template.content.cloneNode(true));
            root.addEventListener('click', (event) => {
              const target = event.target instanceof Element ? event.target : null;
              if (!target?.closest('.bundle-option-radio-label')) return;
              if (target.closest('button, select, a')) return;
              const option = offer.bundleOptions.find(item => item.element === target.closest('.bundle-option'));
              if (!option) return;
              event.preventDefault();
              event.stopImmediatePropagation();
              this.selectPreset(option);
            }, { capture: true, signal: this.controller.signal });
            root.addEventListener('keydown', (event) => {
              if (event.key !== ' ' || !(event.target instanceof HTMLInputElement)) return;
              if (!event.target.matches('.bundle-option-input')) return;
              const option = offer.bundleOptions.find(item => item.element === event.target.closest('.bundle-option'));
              if (!option) return;
              event.preventDefault();
              event.stopImmediatePropagation();
              this.selectPreset(option);
            }, { capture: true, signal: this.controller.signal });
            const syncBadges = () => {
              const header = root.querySelector('.bundle-header');
              if (header && header.textContent !== this.dataset.heading) header.textContent = this.dataset.heading;
              const options = [...root.querySelectorAll('.bundle-option')];
              const titles = [this.dataset.oneLabel, this.dataset.threeLabel, this.dataset.fiveLabel];
              const labels = [null, this.dataset.recommendedLabel, this.dataset.bestPriceLabel];
              options.forEach((option, index) => {
                const unitLabel = option.querySelector('.price-per .discounted-label');
                if (unitLabel && unitLabel.textContent !== this.dataset.unitLabel) unitLabel.textContent = this.dataset.unitLabel;
                const model = offer.bundleOptions.find(item => item.element === option);
                const preset = Number(model?.data.bundleOption.volume_discount.minimum_quantity);
                const quantity = this.displayQuantity(model, offer.selectedBundleOption);
                const custom = model === offer.selectedBundleOption && Number.isSafeInteger(quantity) && quantity !== preset;
                option.toggleAttribute('data-hg-custom-quantity', custom);
                const title = option.querySelector('.title');
                const customTitle = quantity === 1 ? this.dataset.customOneLabel : this.dataset.customManyLabel.replace('[quantity]', String(quantity));
                const text = custom ? customTitle : titles[index];
                if (title && text && title.textContent !== text) title.textContent = text;
                const tierPrice = this.syncPrice(option, quantity);
                if (!tierPrice) this.syncSaving(option);
                this.syncShipping(option, quantity);
                const badge = option.querySelector('.badge');
                if (tierPrice && badge) {
                  const visible = Boolean(labels[index]) && this.dataset.currency === 'EUR';
                  if (badge.classList.contains('active') !== visible) badge.classList.toggle('active', visible);
                }
                if (badge && labels[index] && badge.textContent !== labels[index]) badge.textContent = labels[index];
              });
            };
            const syncSticky = () => {
              const formId = this.closest('product-info')?.getAttribute('form');
              const sticky = formId && document.getElementById(formId.replace('ProductForm-', 'ProductStickyForm-'));
              const total = sticky?.querySelector('[data-hg-sticky-total]');
              const original = sticky?.querySelector('[data-hg-sticky-original]');
              const selected = root.querySelector('.bundle-option-input:checked')?.closest('.bundle-option');
              const title = selected?.querySelector('.title')?.textContent.trim();
              const price = selected?.querySelector('.price-total .discounted')?.textContent.trim();
              if (!total || !original) return;
              total.hidden = !title || !price;
              original.hidden = !total.hidden;
              if (!total.hidden) total.textContent = `${title} · ${price}`;
            };
            this.refreshDisplay = () => { syncBadges(); this.syncQuantity(); syncSticky(); };
            this.bindQuantity(offer, buyRow);
            root.addEventListener('change', this.refreshDisplay, { signal: this.controller.signal });
            offer.addEventListener('section-store:bundle:option-price-refreshed', this.refreshDisplay, { signal: this.controller.signal });
            this.observer?.disconnect();
            this.observer = new MutationObserver(this.refreshDisplay);
            this.observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['checked', 'class'] });
            this.refreshDisplay();
            return;
          }
          if (++attempts < 100) this.timer = setTimeout(attachStyle, 100);
        };
        this.hostObserver?.disconnect();
        this.hostObserver = new MutationObserver(() => { attempts = 0; attachStyle(); });
        this.hostObserver.observe(this, { childList: true, subtree: true });
        attachStyle();
      }
      displayQuantity(model, selected) {
        const quantity = Number(model === selected ? model?.selectedQuantity : model?.data.bundleOption.volume_discount.minimum_quantity);
        return Number.isSafeInteger(quantity) && quantity > 0 ? quantity : null;
      }
      tierPrice(quantity) {
        const unit = Number(this.dataset.unitPrice);
        if (this.dataset.variantId !== '54868923842828' || !this.moneyFormatter || !Number.isSafeInteger(unit) || unit <= 0 || !Number.isSafeInteger(quantity) || quantity < 1) return null;
        const reduction = this.dataset.currency === 'EUR' ? quantity >= 5 ? 510 : quantity >= 3 ? 260 : 0 : 0;
        const original = unit * quantity;
        const total = Math.max(0, unit - reduction) * quantity;
        return Number.isSafeInteger(original) && Number.isSafeInteger(total) ? { original, total, saving: original - total } : null;
      }
      syncPrice(option, quantity) {
        const price = this.tierPrice(quantity);
        const total = option.querySelector('.price-total .discounted');
        if (!price || !total) return false;
        const text = this.moneyFormatter.format(price.total / 100);
        if (total.textContent !== text) total.textContent = text;
        const original = option.querySelector('.price-total .original');
        if (original) {
          const originalText = this.moneyFormatter.format(price.original / 100);
          if (original.textContent !== originalText) original.textContent = originalText;
          if (original.hidden !== (price.saving === 0)) original.hidden = price.saving === 0;
        }
        this.setSaving(option, price.saving, 100);
        const note = this.querySelector('[data-hg-price-note]');
        if (note && note.hidden !== (this.dataset.currency === 'EUR')) note.hidden = this.dataset.currency === 'EUR';
        return true;
      }
      syncShipping(option, quantity) {
        if (this.dataset.freeShippingEnabled !== 'true') return;
        const subtitle = option.querySelector('.subtitle');
        if (!subtitle) return;
        if (!this.shippingSubtitles.has(subtitle)) this.shippingSubtitles.set(subtitle, subtitle.textContent);
        const price = this.tierPrice(quantity);
        const threshold = Number(this.dataset.freeShippingThreshold);
        const eligible = quantity >= 5 && price && threshold > 0 && price.total >= threshold;
        const text = eligible ? this.dataset.freeShippingLabel : this.shippingSubtitles.get(subtitle);
        if (subtitle.textContent !== text) subtitle.textContent = text;
      }
      readPrice(text) {
        if (!this.moneyFormatter || !text) return null;
        const digits = this.moneyFormatter.resolvedOptions().maximumFractionDigits;
        const raw = text.replace(/[^0-9.,-]/g, '');
        if (!raw || raw.includes('-')) return null;
        const decimal = raw.match(/[.,]([0-9]+)$/);
        const hasFraction = digits > 0 && decimal && decimal[1].length <= digits;
        const whole = (hasFraction ? raw.slice(0, decimal.index) : raw).replace(/[.,]/g, '');
        const fraction = hasFraction ? decimal[1].padEnd(digits, '0') : '';
        if (!/^[0-9]+$/.test(whole)) return null;
        const value = Number(whole) * 10 ** digits + Number(fraction || 0);
        return Number.isSafeInteger(value) ? value : null;
      }
      syncSaving(option) {
        const original = this.readPrice(option.querySelector('.price-total .original')?.textContent);
        const discounted = this.readPrice(option.querySelector('.price-total .discounted')?.textContent);
        const saving = original !== null && discounted !== null ? original - discounted : 0;
        this.setSaving(option, saving, this.moneyFormatter ? 10 ** this.moneyFormatter.resolvedOptions().maximumFractionDigits : 100);
      }
      setSaving(option, saving, scale) {
        const badge = option.querySelector('.title-badge');
        if (!badge) return;
        const visible = Number.isSafeInteger(saving) && saving > 0;
        if (badge.hidden === visible) badge.hidden = !visible;
        if (badge.classList.contains('active') !== visible) badge.classList.toggle('active', visible);
        if (visible) {
          const text = this.dataset.savingLabel.replace('[price]', this.moneyFormatter.format(saving / scale));
          if (badge.textContent !== text) badge.textContent = text;
        }
      }
      bindQuantity(offer, buyRow) {
        this.offer = offer;
        this.buyRow = buyRow;
        this.manual = this.querySelector('[data-hg-manual]') || this.manual;
        this.input = this.manual.querySelector('input');
        const signal = this.controller.signal;
        offer.bundleOptions.forEach(option => {
          option.data.bundleOption.quantity_selector = { ...option.data.bundleOption.quantity_selector, enabled: true };
          option.quantitySelector.refresh();
        });
        this.input.id = `HgCalendarQuantity-${this.closest('product-info').id}`;
        this.manual.querySelector('label').htmlFor = this.input.id;
        buyRow.classList.add('hg-calendar-buy-row');
        buyRow.prepend(this.manual);
        this.manual.hidden = false;
        this.input.addEventListener('input', () => { this.quantityPending = true; }, { signal });
        this.input.addEventListener('change', () => this.commitQuantity(), { signal });
        this.input.addEventListener('blur', () => this.commitQuantity(), { signal });
        this.input.addEventListener('keydown', event => {
          if (event.key === 'Enter') { event.preventDefault(); this.commitQuantity(); }
        }, { signal });
      }
      selectPreset(option) {
        this.quantityPending = false;
        const quantity = Number(option.data.bundleOption.volume_discount.minimum_quantity);
        (this.offer.selectedBundleOption || option).changeQuantity(quantity);
        this.refreshDisplay();
      }
      commitQuantity() {
        const selected = this.offer?.selectedBundleOption;
        if (!selected) return;
        const quantity = Number(this.input.value);
        this.quantityPending = false;
        if (!this.input.checkValidity() || !Number.isSafeInteger(quantity)) {
          this.input.reportValidity();
          this.syncQuantity();
          return;
        }
        if (quantity !== Number(selected.selectedQuantity)) selected.changeQuantity(quantity);
        this.refreshDisplay();
      }
      syncQuantity() {
        if (!this.input || !this.offer?.selectedBundleOption || this.quantityPending) return;
        const maximum = Number(this.offer.bundleOptions[0].maximumQuantity);
        if (Number.isSafeInteger(maximum) && maximum > 0) this.input.max = String(maximum);
        else this.input.removeAttribute('max');
        this.input.value = String(this.offer.selectedBundleOption.selectedQuantity);
        this.manual.querySelector('quantity-input')?.validateQtyRules?.();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.hostObserver?.disconnect();
        this.manual?.remove();
        this.buyRow?.classList.remove('hg-calendar-buy-row');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hg-calendar-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hg-calendar-reviews')) {
    customElements.define('hg-calendar-reviews', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.details.open = true;
        this.openReviews = () => {
          this.details.open = true;
        };
        this.onReviewLink = (event) => {
          if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
          const trigger = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge, a[href*="#judgeme_product_reviews"], a[href*="#shopify-product-reviews"]') : null;
          if (trigger) this.openReviews();
        };
        this.onHash = () => {
          if (/judgeme_product_reviews|shopify-product-reviews/.test(window.location.hash)) this.openReviews();
        };
        document.addEventListener('click', this.onReviewLink, true);
        document.addEventListener('keydown', this.onReviewLink, true);
        window.addEventListener('hashchange', this.onHash);
        this.onHash();
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onReviewLink, true);
        document.removeEventListener('keydown', this.onReviewLink, true);
        window.removeEventListener('hashchange', this.onHash);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hg-gift-complements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hg-gift-complements')) {
    customElements.define('hg-gift-complements', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.rail = this.querySelector('.hg-gift-complements__rail');
        this.previous = this.querySelector('[data-hg-prev]');
        this.next = this.querySelector('[data-hg-next]');
        if (!this.rail || !this.previous || !this.next) return;
        this.querySelector('.hg-gift-complements__controls').hidden = false;
        const signal = this.controller.signal;
        const update = () => {
          this.previous.disabled = this.rail.scrollLeft <= 2;
          this.next.disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
        };
        const move = direction => {
          const card = this.rail.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 12;
          this.rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.previous.addEventListener('click', () => move(-1), { signal });
        this.next.addEventListener('click', () => move(1), { signal });
        this.rail.addEventListener('scroll', update, { signal, passive: true });
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.rail);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hg-home-calendar-app"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hg-home-calendar-app')) {
    customElements.define('hg-home-calendar-app', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.failed = false;
        this.controller = new AbortController();
        this.dataset.state = 'loading';
        this.setAttribute('aria-busy', 'true');
        this.loadOfferStarted = false;
        const startLoading = () => {
          if (!this.isConnected || this.loadOfferStarted) return;
          this.loadOfferStarted = true;
          this.loadObserver?.disconnect();
          this.deadline = setTimeout(() => this.showFallback(), 20000);
          this.loadOffer();
        };
        if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
          this.loadObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) startLoading();
          }, { rootMargin: '600px 0px' });
          this.loadObserver.observe(this);
        } else {
          startLoading();
        }
      }
      disconnectedCallback() {
        clearTimeout(this.deadline);
        clearTimeout(this.connectTimer);
        this.loadObserver?.disconnect();
        this.controller?.abort();
        this.started = false;
      }
      showFallback() {
        this.failed = true;
        this.controller?.abort();
        clearTimeout(this.connectTimer);
        this.dataset.state = 'fallback';
        this.setAttribute('aria-busy', 'false');
      }
      connectForm(offer) {
        if (!this.isConnected || this.failed) return;
        const form = this.closest('product-info')?.querySelector('form.product-form[action*="/cart/add"]');
        const root = offer.shadowRoot;
        const checked = root?.querySelector('.bundle-option-input:checked');
        if (!form || !checked) {
          this.connectTimer = setTimeout(() => this.connectForm(offer), 100);
          return;
        }
        const bundle = JSON.parse(offer.dataset.blockBundles)[0];
        const sync = () => {
          const selectedId = root.querySelector('.bundle-option-input:checked')?.value;
          const option = bundle.options.find(item => item.short_id === selectedId);
          if (!option || option.discount_strategy !== 'volume_discount') return false;
          const quantity = Number(offer.selectedBundleOption?.selectedQuantity || option.volume_discount.minimum_quantity);
          if (!Number.isInteger(quantity) || quantity < 1) return false;
          const setInput = (name, value) => {
            let input = [...form.elements].find(field => field.name === name);
            if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
            input.value = String(value);
            input.setAttribute('value', String(value));
          };
          setInput('quantity', quantity);
          setInput('properties[__section_store_bundle]', JSON.stringify({ bundle_id: bundle.short_id, bundle_option_id: option.short_id }));
          return true;
        };
        const signal = this.controller.signal;
        root.addEventListener('change', sync, { signal });
        offer.addEventListener('section-store:bundle:option-price-refreshed', sync, { signal });
        form.addEventListener('submit', sync, { capture: true, signal });
        if (!sync()) { this.showFallback(); return; }
        clearTimeout(this.deadline);
        this.dataset.state = 'ready';
        this.setAttribute('aria-busy', 'false');
        this.querySelector('[data-hg-offer-fallback]')?.setAttribute('hidden', '');
      }
      async loadOffer() {
        try {
          const url = new URL(this.dataset.productUrl, location.origin);
          if (url.origin !== location.origin) throw new Error('Invalid product URL');
          const response = await fetch(url, { credentials: 'same-origin', signal: this.controller.signal });
          if (!response.ok) throw new Error('Product unavailable');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = page.querySelector('section-store--bundle-block');
          if (!source || source.dataset.productId !== this.dataset.productId) throw new Error('Bundle unavailable');
          if (!customElements.get('section-store--bundle-block')) {
            const script = [...page.querySelectorAll('script[src]')].find(item => {
              const asset = new URL(item.src, url);
              return asset.hostname === 'cdn.shopify.com' && asset.pathname.endsWith('/block-bundle.js');
            });
            if (!script) throw new Error('Bundle script unavailable');
            await new Promise((resolve, reject) => {
              this.controller.signal.addEventListener('abort', () => reject(new Error('Loading stopped')), { once: true });
              const existing = [...document.scripts].find(item => item.src === script.src);
              if (existing) { customElements.whenDefined('section-store--bundle-block').then(resolve); return; }
              const asset = document.createElement('script');
              asset.src = script.src;
              asset.onload = resolve;
              asset.onerror = reject;
              document.head.append(asset);
            });
          }
          if (!this.isConnected || this.failed) return;
          this.querySelector('section-store--bundle-block')?.remove();
          const offer = document.importNode(source, true);
          this.append(offer);
          this.connectForm(offer);
        } catch (_) {
          if (this.isConnected) this.showFallback();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hg-home-calendar-bundles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hg-calendar-currency-prices')) {
    customElements.define('hg-calendar-currency-prices', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.currency !== 'CHF' || this.dataset.discountCurrency !== 'EUR') return;
        const currency = window.Shopify?.currency;
        const rate = Number(currency?.rate);
        const unitPrice = Number(this.dataset.unitPrice);
        if (currency?.active !== 'CHF' || !Number.isFinite(rate) || rate <= 0 || !Number.isSafeInteger(unitPrice) || unitPrice < 0) return;
        const formatter = new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF', currencyDisplay: 'code' });
        for (const price of this.querySelectorAll('[data-hg-calendar-price]')) {
          const quantity = Number(price.dataset.hgCalendarPrice);
          const discount = Number(quantity === 3 ? this.dataset.discountThree : this.dataset.discountFive);
          if (![3, 5].includes(quantity) || !Number.isSafeInteger(discount) || discount < 0) continue;
          const convertedDiscount = Math.round(discount * rate);
          const total = Math.max(0, unitPrice - convertedDiscount) * quantity;
          price.textContent = formatter.format(total / 100);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hg-mobile-card-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hg-mobile-card-gallery')) {
    customElements.define('hg-mobile-card-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.startGallery(this.controller.signal);
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      }
      startGallery(signal) {
        if (this.ready) return;
        this.ready = true;
        const track = this.querySelector('.hg-mobile-card-gallery__track');
        const template = this.querySelector('template');
        if (track.children.length === 1) track.append(template.content.cloneNode(true));
        const pagination = this.querySelector('.hg-mobile-card-gallery__dots');
        const dots = this.querySelectorAll('[data-hg-gallery-dot]');
        const status = this.querySelector('[data-hg-gallery-status]');
        let current = -1;
        const update = () => {
          const index = Math.max(0, Math.min(track.children.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
          if (index === current) return;
          current = index;
          dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
          status.textContent = status.dataset.label.replace('[index]', String(index + 1));
        };
        const goTo = target => track.scrollTo({ left: Math.max(0, Math.min(track.children.length - 1, target)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        dots.forEach(dot => dot.addEventListener('click', () => goTo(Number(dot.dataset.hgGalleryDot)), { signal }));
        track.addEventListener('scroll', update, { signal, passive: true });
        track.addEventListener('keydown', event => {
          const index = Math.round(track.scrollLeft / (track.clientWidth || 1));
          const targets = { ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: track.children.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          goTo(targets[event.key]);
        }, { signal });
        let drag = null;
        let moved = false;
        track.addEventListener('pointerdown', event => {
          moved = false;
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft };
        }, { signal, passive: true });
        track.addEventListener('pointermove', event => {
          if (!drag || drag.id !== event.pointerId) return;
          const dx = event.clientX - drag.x;
          if (!moved && (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(event.clientY - drag.y))) return;
          moved = true;
          event.preventDefault();
          track.classList.add('is-dragging');
          if (!track.hasPointerCapture(event.pointerId)) track.setPointerCapture(event.pointerId);
          track.scrollLeft = drag.left - dx;
        }, { signal });
        const finishDrag = event => {
          if (!drag || drag.id !== event.pointerId) return;
          drag = null;
          track.classList.remove('is-dragging');
          if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
          if (moved) goTo(Math.round(track.scrollLeft / (track.clientWidth || 1)));
        };
        track.addEventListener('pointerup', finishDrag, { signal });
        track.addEventListener('pointercancel', finishDrag, { signal });
        track.addEventListener('lostpointercapture', () => { drag = null; track.classList.remove('is-dragging'); }, { signal });
        track.addEventListener('dragstart', event => event.preventDefault(), { signal });
        track.addEventListener('click', event => {
          if (!moved) return;
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }, { signal, capture: true });
        if (pagination) pagination.hidden = false;
        update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.ready = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hg-product-crosssell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hg-crosssell-total')) {
    customElements.define('hg-crosssell-total', class extends HTMLElement {
      connectedCallback() {
        this.prices = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
        this.form = document.getElementById(this.dataset.formId);
        this.details = this.closest('details');
        this.refresh = () => queueMicrotask(() => this.update());
        this.onInput = (event) => {
          if (event.target.form === this.form || this.details.contains(event.target)) this.refresh();
        };
        this.form?.addEventListener('bundle:change', this.refresh);
        document.addEventListener('change', this.onInput);
        document.addEventListener('input', this.onInput);
        this.refresh();
      }
      disconnectedCallback() {
        this.form?.removeEventListener('bundle:change', this.refresh);
        document.removeEventListener('change', this.onInput);
        document.removeEventListener('input', this.onInput);
      }
      update() {
        if (!this.isConnected || !this.form) return;
        const selected = [...this.details.querySelectorAll('input[name="bundles"]:checked:not(:disabled)')];
        const mainId = this.form.elements.namedItem('id')?.value;
        const quantity = Math.max(1, Number(this.form.elements.namedItem('quantity')?.value) || 1);
        const base = this.prices[mainId];
        const total = base * quantity + selected.reduce((sum, input) => sum + Number(input.dataset.price) * Number(input.dataset.min), 0);
        this.querySelector('[data-total-row]').hidden = selected.length === 0 || !Number.isFinite(total);
        if (Number.isFinite(total)) this.querySelector('[data-total]').textContent = new Intl.NumberFormat(this.dataset.currency === 'EUR' ? 'de-DE' : this.dataset.locale, {style:'currency',currency:this.dataset.currency}).format(total / 100);
        for (const button of document.querySelectorAll(`button[type="submit"][form="${this.dataset.formId}"]`)) {
          const label = button.querySelector('.btn-text > span');
          if (!label) continue;
          if (!button.dataset.hgOriginalLabel) {
            button.dataset.hgOriginalLabel = label.textContent;
            button.dataset.hgOriginalAria = button.getAttribute('aria-label') || label.textContent;
          }
          label.textContent = selected.length ? this.dataset.selectedLabel : button.dataset.hgOriginalLabel;
          button.setAttribute('aria-label', selected.length ? this.dataset.selectedLabel : button.dataset.hgOriginalAria);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hg-recipient-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hg-recipient-guide')) {
    customElements.define('hg-recipient-guide', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const navigation = this.querySelector('.hg-recipient-guide__nav');
          const current = navigation?.querySelector('[aria-current="page"]');
          if (!current || navigation.scrollWidth <= navigation.clientWidth) return;
          const navigationBox = navigation.getBoundingClientRect();
          const currentBox = current.getBoundingClientRect();
          navigation.scrollLeft += currentBox.left - navigationBox.left - (navigation.clientWidth - currentBox.width) / 2;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hg-reviewforest-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hg-reviewforest-panel')) {
    customElements.define('hg-reviewforest-panel', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.bindDetails(), { once: true, signal: this.abortController.signal });
        } else {
          this.bindDetails();
        }
      }
      bindDetails() {
        const details = this.querySelector('details');
        if (!details) return;
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          if (!this.querySelector('iframe')) {
            const frame = document.createElement('iframe');
            frame.title = this.dataset.frameTitle;
            frame.src = this.dataset.forestUrl;
            frame.referrerPolicy = 'strict-origin-when-cross-origin';
            frame.addEventListener('load', () => {
              this.querySelector('[data-forest-loading]').hidden = true;
            }, { once: true });
            this.querySelector('[data-forest-viewer]').append(frame);
          }
          details.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hg-tea-quantity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hg-tea-quantity')) {
    customElements.define('hg-tea-quantity', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.frame = requestAnimationFrame(() => this.bind());
      }

      bind() {
        if (!this.isConnected) return;
        this.info = this.closest('product-info');
        this.form = document.getElementById(this.dataset.formId);
        this.input = this.form?.elements.namedItem('quantity');
        const variantData = this.querySelector('[data-hg-variants]');
        if (!this.info || !this.form || !this.input || !variantData) return;
        this.variants = JSON.parse(variantData.textContent);
        this.variant = this.variants.find(variant => String(variant.id) === this.dataset.variantId);
        this.buttons = [...this.querySelectorAll('[data-hg-preset]')];
        if (!this.input.dataset.hgDefaultApplied) {
          const minimum = Math.max(1, Number(this.input.min) || 1);
          const maximum = Math.min(this.input.max === '' ? Infinity : Number(this.input.max), this.variant?.limited ? this.variant.stock : Infinity);
          const step = Number(this.input.step) || 1;
          if (this.variant?.available && minimum <= 3 && maximum >= 3 && (3 - minimum) % step === 0) this.input.value = '3';
          this.input.dataset.hgDefaultApplied = 'true';
          this.input.dispatchEvent(new Event('input', { bubbles: true }));
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const signal = this.controller.signal;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-hg-preset]');
          if (!button || !this.contains(button) || button.disabled) return;
          this.input.value = button.dataset.hgPreset;
          this.input.dispatchEvent(new Event('input', { bubbles: true }));
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
          this.update();
        }, { signal });
        this.addEventListener('keydown', event => {
          const current = event.target.closest('[data-hg-preset]');
          if (!current || !this.contains(current)) return;
          const keys = ['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          const choices = this.buttons.filter(button => !button.disabled);
          if (!choices.length) return;
          event.preventDefault();
          const index = choices.indexOf(current);
          const direction = event.key === 'ArrowUp' || event.key === 'ArrowLeft' ? -1 : 1;
          const next = event.key === 'Home' ? choices[0] : event.key === 'End' ? choices[choices.length - 1] : choices[(index + direction + choices.length) % choices.length];
          next.focus();
          next.click();
        }, { signal });
        this.info.addEventListener('input', event => { if (event.target === this.input) this.update(); }, { signal });
        this.info.addEventListener('change', event => { if (event.target === this.input) this.update(); }, { signal });
        this.form.addEventListener('variant:change', event => {
          const selected = event.detail?.variant;
          this.variant = selected ? this.variants.find(variant => String(variant.id) === String(selected.id)) : null;
          if (this.variant && Number.isFinite(selected.price)) this.variant = { ...this.variant, price: selected.price, available: selected.available };
          this.update();
        }, { signal });
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.input, { attributes: true, attributeFilter: ['min', 'max', 'step', 'disabled'] });
        const variantInput = this.form.elements.namedItem('id');
        if (variantInput) this.observer.observe(variantInput, { attributes: true, attributeFilter: ['disabled'] });
        const pubsub = window.theme?.pubsub;
        if (pubsub?.PUB_SUB_EVENTS?.quantityUpdate) {
          this.unsubscribe = pubsub.subscribe(pubsub.PUB_SUB_EVENTS.quantityUpdate, () => this.update());
        }
        this.update();
        this.hidden = false;
      }

      formatMoney(amount) {
        try {
          return new Intl.NumberFormat(this.dataset.currency === 'EUR' ? 'de-DE' : this.dataset.locale, {
            style: 'currency',
            currency: this.dataset.currency,
            currencyDisplay: this.dataset.currency === 'EUR' ? 'symbol' : this.dataset.currencyCode === 'true' ? 'code' : 'narrowSymbol'
          }).format(amount / 100);
        } catch (error) {
          const theme = window.theme;
          if (theme?.Currency?.formatMoney) {
            const format = this.dataset.currencyCode === 'true' ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat;
            return theme.Currency.formatMoney(amount, format);
          }
          return `${(amount / 100).toFixed(2)} ${this.dataset.currency}`;
        }
      }

      total(quantity) {
        const unitDiscount = quantity >= 5 ? 92 : quantity >= 3 ? 60 : 0;
        return (this.variant.price - unitDiscount) * quantity;
      }

      update() {
        const quantity = Number(this.input.value);
        const minimum = Math.max(1, Number(this.input.min) || 1);
        const maximum = Math.min(this.input.max === '' ? Infinity : Number(this.input.max), this.variant?.limited ? this.variant.stock : Infinity);
        const step = Number(this.input.step) || 1;
        const available = Boolean(this.variant?.available) && !this.input.disabled && !this.form.elements.namedItem('id')?.disabled;
        const valid = Number.isSafeInteger(quantity) && quantity >= minimum && quantity <= maximum && (quantity - minimum) % step === 0;
        const tier = quantity >= 5 ? 5 : quantity >= 3 ? 3 : 1;
        this.buttons.forEach(button => {
          const preset = Number(button.dataset.hgPreset);
          const selected = Boolean(this.variant && available && valid && preset === tier);
          const displayedQuantity = selected ? quantity : preset;
          button.disabled = !available || preset < minimum || preset > maximum || (preset - minimum) % step !== 0;
          button.setAttribute('aria-checked', String(selected));
          button.tabIndex = selected ? 0 : -1;
          button.querySelector('[data-hg-preset-quantity]').textContent = displayedQuantity === preset ? button.dataset.hgPresetTitle : this.dataset.piecesLabel.replace('[quantity]', String(displayedQuantity));
          button.querySelector('[data-hg-subtitle]').hidden = displayedQuantity !== preset;
          const original = this.variant ? this.variant.price * displayedQuantity : 0;
          const total = this.variant ? this.total(displayedQuantity) : 0;
          const saving = original - total;
          button.querySelector('[data-hg-price]').textContent = this.variant ? this.formatMoney(total) : '';
          const originalNode = button.querySelector('[data-hg-original]');
          originalNode.hidden = saving <= 0;
          originalNode.textContent = saving > 0 ? this.formatMoney(original) : '';
          const savingNode = button.querySelector('[data-hg-saving]');
          savingNode.hidden = saving <= 0;
          savingNode.textContent = saving > 0 ? this.dataset.savingLabel.replace('[amount]', this.formatMoney(saving)) : '';
        });
        if (!this.buttons.some(button => button.tabIndex === 0)) {
          const first = this.buttons.find(button => !button.disabled);
          if (first) first.tabIndex = 0;
        }
        const totalRow = this.querySelector('[data-hg-total]');
        totalRow.hidden = !this.variant || !valid || !available;
        if (!totalRow.hidden) {
          const totalText = this.formatMoney(this.total(quantity));
          const quantityText = `${this.dataset.piecesLabel.replace('[quantity]', String(quantity))}, `;
          const quantityValue = totalRow.querySelector('[data-hg-total-quantity]');
          if (quantityValue.textContent !== quantityText) quantityValue.textContent = quantityText;
          const totalValue = totalRow.querySelector('[data-hg-total-value]');
          if (totalValue.textContent !== totalText) totalValue.textContent = totalText;
        }
        const sticky = document.getElementById(this.dataset.formId.replace('ProductForm-', 'ProductStickyForm-'));
        const stickyTotal = sticky?.querySelector('[data-hg-sticky-total]');
        const stickyOriginal = sticky?.querySelector('[data-hg-sticky-original]');
        if (stickyTotal && stickyOriginal) {
          stickyTotal.hidden = totalRow.hidden;
          stickyOriginal.hidden = !totalRow.hidden;
          if (!totalRow.hidden) {
            const pieces = this.dataset.piecesLabel.replace('[quantity]', String(quantity));
            stickyTotal.textContent = `${pieces} · ${this.formatMoney(this.total(quantity))}`;
          }
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.unsubscribe?.();
        this.hidden = true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
